import { useMemo } from 'react';
import { useParams } from 'react-router';

import { AxiosError } from 'axios';
import { isEqual } from 'lodash';
import useSWR, { mutate } from 'swr';

import { apiClient } from '@src/clients';
import {
  ErrorMessageAOINotFound,
  HTTPValidationError
} from '@src/clients/atlas/api';

export const useGetActiveAoi = () => {
  const { aoi_id } = useParams();

  const CACHE_KEY = `aoi/${aoi_id}`;

  const { data, isLoading, error } = useSWR(
    aoi_id ? CACHE_KEY : null,
    () => apiClient.atlasApi.aoi.getAoiAoiAoiIdGet(aoi_id as string),
    {
      onError: console.error,
      revalidateOnFocus: false,
      refreshInterval: 0,
      revalidateOnReconnect: false,
      shouldRetryOnError: error =>
        error.response?.status !== 403 && error.response?.status !== 404,
      compare: (a, b) => isEqual(a?.data, b?.data)
    }
  );

  return useMemo(
    () => ({
      activeAoi: data?.data ?? null,
      isLoading,
      error: error as AxiosError<ErrorMessageAOINotFound | HTTPValidationError>,
      refetch: () => mutate(CACHE_KEY)
    }),
    [data, isLoading, error]
  );
};

useGetActiveAoi.displayName = 'useGetActiveAoi';
